import { FormlyFieldConfig } from "@ngx-formly/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";

export function validateDependentField(control: AbstractControl, field: FormlyFieldConfig, requiredFields: string[], validationKey: string): ValidationErrors | null {
  const value = control.value;

  // Check if required is true in the field's props
  if (field.props?.required) {
    // Check if any of the required fields are null, undefined, or empty
    const isInvalid = requiredFields.some(
      (f) => !value?.[f]?.toString().trim()
    );

    return isInvalid ? getValidationError(validationKey) : null;
  }
  return null;
}

function getValidationError(validationKey: string): ValidationErrors {
  const validationObject = {} as ValidationErrors;
  validationObject[validationKey] = true;
  return validationObject;
}
